export default __webpack_public_path__ + "media/images/32-369d7483f012f0e41729c4c2dfa62c71.png";